import {
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    DoughnutController,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip,
} from "chart.js";
import { readDashboardChartColors } from "./dashboardChartColors";

let registered = false;

function ensureRegistered() {
    if (!registered) {
        Chart.register(
            BarController,
            BarElement,
            CategoryScale,
            LinearScale,
            Tooltip,
            Legend,
            DoughnutController,
            ArcElement,
            LineController,
            LineElement,
            PointElement,
        );
        registered = true;
    }
}

function resolveColors(canvas) {
    const root = canvas?.closest?.(".dashboard-wrapper") ?? null;
    return readDashboardChartColors(root);
}

function defaultCartesianOptions(colors) {
    return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { labels: { color: colors.text } },
            tooltip: {},
        },
        scales: {
            x: {
                ticks: { color: colors.text },
                grid: { color: colors.gridSubtle },
            },
            y: {
                beginAtZero: true,
                ticks: { color: colors.text },
                grid: { color: colors.grid },
            },
        },
    };
}

function mergeBarOptions(base, extra) {
    return {
        ...base,
        ...extra,
        plugins: {
            ...base.plugins,
            ...(extra.plugins || {}),
            legend: { ...base.plugins.legend, ...(extra.plugins?.legend || {}) },
        },
        scales: {
            x: {
                ...base.scales.x,
                ...extra.scales?.x,
                ticks: { ...base.scales.x.ticks, ...extra.scales?.x?.ticks },
            },
            y: {
                ...base.scales.y,
                ...extra.scales?.y,
                ticks: { ...base.scales.y.ticks, ...extra.scales?.y?.ticks },
            },
        },
    };
}

export function createBarChart(canvas, { labels, datasets }, extraOptions = {}) {
    ensureRegistered();
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        return null;
    }
    const colors = resolveColors(canvas);
    return new Chart(ctx, {
        type: "bar",
        data: { labels, datasets },
        options: mergeBarOptions(defaultCartesianOptions(colors), extraOptions),
    });
}

export function createDoughnutChart(canvas, { labels, data }) {
    ensureRegistered();
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        return null;
    }
    const colors = resolveColors(canvas);
    return new Chart(ctx, {
        type: "doughnut",
        data: {
            labels,
            datasets: [
                {
                    data,
                    backgroundColor: data.map(
                        (_, index) => colors.doughnutSlices[index % colors.doughnutSlices.length],
                    ),
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { labels: { color: colors.text } },
            },
        },
    });
}
